<template>
  <q-card flat square>
    <div class="text-center row justify-center q-py-xs">
      <q-chip
        square
        dense
        class="text-center text-bold q-px-md q-my-sm glossy"
        :color="gltvColor"
        text-color="white"
        style="font-size: 13px; max-width: 150px; margin: 0px; overflow: hidden"
        classes="ellipsis"
        :icon-right="gltvIcon"
      >
        {{ gltvLabel }}
      </q-chip>
    </div>

    <div style="height: 285px; overflow-y: auto">
      <q-virtual-scroll
        :items="gltvtData"
        :items-per-page="10"
        virtual-scroll-item-size="50"
      >
        <template v-slot="{ item }">
          <q-table
            :class="
              $q.dark.mode ? 'table-header-column-dark' : 'table-header-column'
            "
            flat
            square
            dense
            hide-bottom
            hide-header
            :pagination="pagination"
            :rows="[item]"
            :columns="columns"
            row-key="symbol"
            bordered
            binary-state-sort
            separator="cell"
          >
            <template v-slot:body-cell-symbol="props">
              <q-td
                :props="props"
                style="padding-left: 5px; padding-right: 0px"
              >
                <span
                  class="q-ma-none q-pa-none cursor-pointer"
                  dense
                  clickable
                  @click="handlePropsValue(props.value)"
                >
                  <div class="col">
                    {{ props.value }}
                    <q-tooltip>
                      {{
                        allStocks.find(
                          (stock) =>
                            stock.symbol ===
                            props.value
                              .substring(0, props.value.indexOf("("))
                              .trim()
                        )?.name
                      }}
                    </q-tooltip>
                  </div>
                </span>
              </q-td>
            </template>

            <template v-slot:no-data>
              <div class="text-center q-pa-md">No Data Available</div>
            </template>
          </q-table>
        </template>
      </q-virtual-scroll>
    </div>
  </q-card>
</template>

<script setup>
import { ref, computed } from "vue";
import useUtils from "src/use/utils";
import { useStore } from "vuex";

const props = defineProps({
  gltv: {
    type: String,
  },
  gltvtData: {
    type: Array,
  },
  isMarketOn: {
    type: Boolean,
    required: false,
    default: false,
  },
  sectorId: {
    type: Number,
    required: false,
    default: null,
  },
});

const emit = defineEmits(["propsValue"]);

const { amountConversion } = useUtils();
const store = useStore();
const allStocks = ref(store.state.core.allStocks);

const gltvColor = computed(() => {
  return props.gltv === "gainer"
    ? "teal-5"
    : props.gltv === "looser"
    ? "red-5"
    : "primary";
});

const gltvIcon = computed(() => {
  return props.gltv === "gainer"
    ? "trending_up"
    : props.gltv === "looser"
    ? "trending_down"
    : props.gltv === "volume"
    ? "equalizer"
    : "currency_rupee";
});

const gltvLabel = computed(() => {
  return props.gltv === "gainer"
    ? "Top Gainer"
    : props.gltv === "looser"
    ? "Top Looser"
    : props.gltv === "transaction"
    ? "Top Transaction"
    : props.gltv === "volume"
    ? "Top Volume"
    : "Top Turnover";
});

const columns = computed(() => {
  switch (props.gltv) {
    case "turnover":
      return [
        {
          name: "symbol",
          label: "Symbol",
          field: "symbol",
          format: (val, row) => val + "(" + amountConversion(row.amount) + ")",
          align: "center",
          style: "max-width: 15px; font-size:12px;color:#1976D2;",
          classes: "ellipsis",
        },
      ];
    case "volume":
      return [
        {
          name: "symbol",
          label: "Symbol",
          field: "symbol",
          format: (val, row) => val + "(" + amountConversion(row.volume) + ")",
          align: "center",
          style: "max-width: 15px; font-size:12px;color:#1976D2;",
          classes: "ellipsis",
        },
      ];
    case "transaction":
      return [
        {
          name: "symbol",
          label: "Symbol",
          field: "symbol",
          format: (val, row) => val + " (" + row.count + ")",
          align: "center",
          style: "max-width: 15px; font-size:12px;color:#1976D2;",
          classes: "ellipsis",
        },
      ];
    default:
      return [
        {
          name: "symbol",
          label: "Symbol",
          field: "symbol",
          format: (val, row) =>
            val + ` (${row.percentage_change.toFixed(2)} %)`,
          align: "center",
          style:
            props.gltv === "gainer"
              ? "max-width: 15px; font-size:12px;color:green;"
              : "max-width: 15px; font-size:12px;color:red;",
          classes: "ellipsis",
        },
      ];
  }
});

const pagination = ref({
  sortBy: "percentage_change",
  descending: true,
  rowsPerPage: 0,
});

function handlePropsValue(value) {
  emit("propsValue", value.substring(0, value.indexOf("(")).trim());
}
</script>
